import { createAction } from '@sde/widgets-core/src/redux/helpers/createAction';
import { ADD_ALERT, REMOVE_ALERT, SHOW_ALERT, CLEAR_ALERTS } from './constants';

export const addAlert = (alert) => {
  return createAction({
    type: ADD_ALERT,
    payload: alert,
  });
};

export const removeAlert = (id) => {
  return createAction({
    type: REMOVE_ALERT,
    payload: id,
  });
};

export const clearAlerts = () => {
  return createAction({
    type: CLEAR_ALERTS,
  });
};

export const showAlert = (alert = {}) => {
  return (dispatch) => {
    const data = alert.data || alert;
    dispatch({
      type: SHOW_ALERT,
      payload: {
        variant: data.variant || 'error',
        message: data.message,
        code: data.code || data.statusCode || 'Error',
      },
    });
  };
};
